import React from "react";
import PropTypes from "prop-types";
import "./StatisticsCards.css";

const StatisticsCards = ({ stats, loading = false }) => {
	const formatValue = (value, format = "number") => {
		if (value === null || value === undefined) return "0";
		switch (format) {
			case "currency":
				return `₹${parseFloat(value).toLocaleString("en-IN")}`;
			case "percentage":
				return `${parseFloat(value).toFixed(2)}%`;
			case "number":
			default:
				return typeof value === "number" ? value.toLocaleString("en-IN") : value;
		}
	};

	return (
		<div className="row">
			{stats.map((stat, index) => (
				<div className={`col-xl-${12 / stats.length} col-sm-6`} key={index}>
					<div className="card">
						<div className="card-body">
							<div className="media align-items-center text-center">
								<div className="media-body">
									{loading ? (
										<div className="skeleton-loader">
											<div className="skeleton-text" style={{ width: "60%" }}></div>
											<div className="skeleton-text" style={{ width: "40%" }}></div>
										</div>
									) : (
										<>
											<h2 className={`fs-38 text-black font-w600 ${stat.className || ""}`}>
												{formatValue(stat.value, stat.format)}
											</h2>
											<span className="fs-16">{stat.title}</span>
											{stat.subtitle && (
												<p className="text-muted mb-0 mt-1">{stat.subtitle}</p>
											)}
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

StatisticsCards.propTypes = {
	stats: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			format: PropTypes.oneOf(["number", "currency", "percentage"]),
			className: PropTypes.string,
			subtitle: PropTypes.string,
			icon: PropTypes.string,
			color: PropTypes.string,
		})
	).isRequired,
	loading: PropTypes.bool,
};

export default StatisticsCards;
